/* tslint:disable */
/* eslint-disable */
/**
 * lq.api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RiskScoreQualitativeScore
 */
export interface RiskScoreQualitativeScore {
    /**
     * 
     * @type {string}
     * @memberof RiskScoreQualitativeScore
     */
    tc?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RiskScoreQualitativeScore
     */
    value?: string | null;
}

export function RiskScoreQualitativeScoreFromJSON(json: any): RiskScoreQualitativeScore {
    return RiskScoreQualitativeScoreFromJSONTyped(json, false);
}

export function RiskScoreQualitativeScoreFromJSONTyped(json: any, ignoreDiscriminator: boolean): RiskScoreQualitativeScore {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tc': !exists(json, 'tc') ? undefined : json['tc'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function RiskScoreQualitativeScoreToJSON(value?: RiskScoreQualitativeScore | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'tc': value.tc,
        'value': value.value,
    };
}


